import React, { createContext, useState } from "react";

export const CursorContext = createContext<{
  cursor: number;
  setCursor: React.Dispatch<React.SetStateAction<number>>;
}>({ cursor: 0, setCursor: () => {} });

export function CursorProvider({
  children,
}: React.PropsWithChildren): React.ReactElement {
  const [cursor, setCursor] = useState(0);
  // ...
  return (
    <CursorContext.Provider value={{ cursor, setCursor }}>
      {children}
    </CursorContext.Provider>
  );
}
